import {BEAST_ACADEMY_MODALITY_SLUG} from "./const";

/**
 * Whether a modality slug is Beast Academy.
 *
 * Slug-level so server and client components can branch on Beast Academy
 * without importing the learning-format components.
 */
export function isBeastAcademyModalitySlug(slug: string | null | undefined) {
	return slug === BEAST_ACADEMY_MODALITY_SLUG;
}
